import { motion } from "framer-motion";
import { useState } from "react";

export const WhyChooseUsV2 = (props: any) => {
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  return (
    <section className="relative py-28 bg-gradient-to-br from-gray-50 to-white text-gray-900">
      {/* Light Background Grid */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
        <svg width="100%" height="100%">
          <defs>
            <pattern id="grid-light" width="80" height="80" patternUnits="userSpaceOnUse">
              <path d="M 0 40 H 80" stroke="#999" strokeWidth="0.35" />
              <path d="M 40 0 V 80" stroke="#999" strokeWidth="0.35" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-light)" />
        </svg>
      </div>

      {/* Section Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="max-w-7xl mx-auto px-6 mb-20 text-center md:text-left"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
          {props.title}
        </h2>

        <h3 className="text-4xl md:text-5xl font-extrabold text-red-600 mt-2">
          {props.subTitle}
        </h3>

        <p className="text-gray-600 text-lg md:text-xl mt-6 max-w-3xl">
          {props.description}
        </p>
      </motion.div>

      {/* Cards */}
      <div className="
        grid 
        grid-cols-1 
        sm:grid-cols-2 
        lg:grid-cols-4 
        gap-10 
        px-6 
        max-w-7xl 
        mx-auto
      ">
        {props.features.map((f: any, i: number) => (
          <motion.div
            key={i}
            onMouseEnter={() => setHoverIndex(i)}
            onMouseLeave={() => setHoverIndex(null)}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.12, duration: 0.8 }}
            viewport={{ once: true }}
            animate={{
              scale: hoverIndex === i ? 1.04 : 1,
            }}
            className="
              relative 
              p-10 
              rounded-2xl 
              cursor-pointer
              bg-white 
              border border-gray-200 
              shadow-sm hover:shadow-lg
              transition-all 
              duration-300 
              text-center
              min-h-[260px]
              flex flex-col
              items-center
            "
          >
            {/* Icon */}
            <div 
              className={`
                text-red-600 text-5xl mb-6 transition-transform duration-300
                ${hoverIndex === i ? "scale-110" : "scale-100"}
              `}
            >
              {f.icon}
            </div>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              {f.title}
            </h3>

            <p className="text-gray-600 text-base leading-relaxed">
              {f.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
